var ipAddr = "";

function postIpActions(){

  if(ipAddr == "92.207.214.98"){

    initDebugInfoAndStaffLinks();
    
  }else{

    jQuery("div#hss_staff_links").hide();
    hideHssDebugInfo();
  
  }
  
}

function initDebugInfoAndStaffLinks(){

  //console.log("|" + hss_sl_collection_id);

  //not cookie based any more
  if(ipAddr == "92.207.214.98"){

    setTimeout(function(){

      jQuery("a#hss-debug-show").on("click", function(){

        showHssDebugInfo();

      });

      if(getCookie('hss-show-debug-info') == 1){

        showHssDebugInfo();
      
      }

      jQuery("a#hss_debug_info_close").on("click", function(){

        hideHssDebugInfo();

      });

      jQuery("a#hss-check-collection").on("click", function(){

        checkCollectionUrlIsKosher();

      });

      if(hss_sl_collection_id != ''){

        checkCollectionUrlIsKosher();

      }

      jQuery("a#hss-redir-queue-src").on("click", function(){

        queueForRedirSource();

      });

      jQuery("a#hss-redir-queue-tgt").on("click", function(){

        queueForRedirTarget();

      });

    }, 250);

  }else{

    jQuery("div#hss_staff_links").hide();
    hideHssDebugInfo();
  
  }

}

function queueForRedirSource(){

  setCookie('hss-redir-queue-src', window.location.href.replace('https://www.herringshoes.co.uk', ''), 30);

  navigator.clipboard.writeText("'" + window.location.href.replace('https://www.herringshoes.co.uk', '') + "' => '" + getCookie('hss-redir-queue-tgt') + "',");

}

function queueForRedirTarget(){

  setCookie('hss-redir-queue-tgt', window.location.href.replace('https://www.herringshoes.co.uk', ''), 30);

  navigator.clipboard.writeText("'" + getCookie('hss-redir-queue-src') + "' => '" + window.location.href.replace('https://www.herringshoes.co.uk', '') + "',");

}

function checkCollectionUrlIsKosher(){

  //console.log("checking |" + requestPath + "|");

  var collnCheckResponse = jQuery.get('https://www.herringshoes.co.uk/tools/hss-utils/ajaxHandler.php?task=collectionUrlIsKosher&collection_url=' + encodeURIComponent(requestPath), '', function(data){
            
      if(data){

        //console.log(data);

          if(data.success){

            jQuery("a#hss-check-collection").text("Collection URL: OK :-)");

          }else{

            jQuery("a#hss-check-collection").text("Collection URL: NOT OK :-(");

          }
          
      }
  
  }, 'json');

}

function hideHssDebugInfo(){

  jQuery("div#hss_debug_info").hide();

  setCookie('hss-show-debug-info', 0, 30);

}

function showHssDebugInfo(){

  if(ipAddr == "92.207.214.98"){

      jQuery("div#hss_debug_info").css(
      {
        "top": jQuery("div.utility-bar").first().height(),
        "z-index": 9999999999
      }
      ).show();

      setCookie('hss-show-debug-info', 1, 30);

  }

}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

var applyDefaultSizeSelection = true;
var lastSelectedSizeName = '';

function initProductPage(){

  jQuery('#accordion').accordion({
    collapsible: true,
    active: false,
    heightStyle: "content",
    icons: { "header": "ui-icon-plus", "activeHeader": "ui-icon-minus" }
  });

  jQuery("a.hss-shoe-size-table-popup").on("click", function(){});

  if(jQuery("input.hss-size-selector:checked:enabled")){

    var sizeChosenText = jQuery("input.hss-size-selector:checked:enabled").val();

    if(sizeChosenText && sizeChosenText != '' && sizeChosenText != 'undefined'){

      setSizeChosenHint(sizeChosenText);

      setAddToCartButtonText("Add " + sizeChosenText + " to cart");

    }

  }

  /*document.addEventListener('variant:change', function(event) {

    if(ipAddr == "92.207.214.98"){

        // Access the newly selected variant data
        const selectedVariant = event.detail.variant;

        // Log the variant details to the console (for testing)
        console.log('Variant changed:', selectedVariant);
        console.log('Variant ID:', selectedVariant.id);
        console.log('Variant Price:', selectedVariant.price);
        
        // Add your custom logic here (e.g., updating another element on the page)

    }

  });

 jQuery("input.hss-size-selector").unbind("click").on("click", function(){

    if(ipAddr == "92.207.214.98"){

      console.log('input.hss-size-selector clicked');

    }

    lastSelectedSizeName = jQuery(this).val();

    if(ipAddr == "92.207.214.98"){

      console.log(lastSelectedSizeName);

    }

  });

 jQuery("input.hss-size-selector").on("click", function(){

    setCookie('hss-last-size', jQuery(this).val(), 30);

  });

  var lastSizeSelected = getCookie('hss-last-size');

  if(lastSizeSelected != null){

    //try to preselect the same size for the customer
    //preselectSizeIfPoss(lastSizeSelected);

  }

  //console.log(applyDefaultSizeSelection);

  if(applyDefaultSizeSelection){

    jQuery("input.hss-size-selector").each(function(idx, elem){

      //console.log(jQuery(elem).data('checkthis'));

      if(jQuery(elem).data('checkthis') == '1'){

        jQuery(elem).prop('checked', 'checked');

      }

    });
  
  }*/

}

function handleSizeChange2(selectedOptionValues){

  setTimeout(function(){

    if(selectedOptionValues[1]){

      var selectedSizeInputVal = jQuery("input.hss-size-selector[data-option-value-id='" + selectedOptionValues[1] + "']").val();

      if(selectedSizeInputVal && selectedSizeInputVal != '' && selectedSizeInputVal != 'undefined'){

        setAddToCartButtonText("Add " + selectedSizeInputVal + " to cart");

      }else{

        setAddToCartButtonText("Add to cart");
      
      }

    }else{

      setAddToCartButtonText("Add to cart");
    
    }

  }, 500);

}

function setAddToCartButtonText(toText){

  jQuery("span#hss-add-to-cart-span").text(toText);

}

function handleSizeChange(newSizeValue){

    lastSelectedSizeName = newSizeValue;

    if(newSizeValue && newSizeValue != '' && jQuery("span#hss-add-to-cart-span")){

      setSizeChosenHint(newSizeValue);

    }

}

function setSizeChosenHint(sizeChosen){

  if(sizeChosen && sizeChosen != '' && sizeChosen != 'undefined'){

  jQuery("span#hss-size-chosen").text("Size chosen: " + sizeChosen);

  }else{

    jQuery("span#hss-size-chosen").text("");
  
  }

}

function preselectSizeIfPoss(sizeText){

  //console.log("Last size selected was " + sizeText);

  jQuery("input.hss-size-selector").each(function(idx, elem){

    var thisText = jQuery(elem).val();

    //console.log("Comparing" + thisText + " with saved " + sizeText);

    if(thisText == sizeText){

      //console.log("It matches, checking if disabled");

      if(jQuery(elem).prop('disabled') == false){

        console.log("Not disabled, selecting");

        jQuery(elem).prop('checked', 'checked');

        applyDefaultSizeSelection = false;

      }else{

        //console.log("Disabled, cannot select");

      }

    }

  });

}

function handleShopifyInboxClicks(){

  jQuery("a.shopifyInboxLink").on("click", function(){ 

    const chatElement = document?.getElementById(`ShopifyChat`)?.shadowRoot?.querySelector('.chat-app>button');

    chatElement.click();
  
  });

}

if (window.innerWidth > 990) {
  document.querySelectorAll('details.mega-menu').forEach(menu => {
    const summary = menu.querySelector('summary');

    menu.addEventListener('mouseenter', () => {
      menu.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    menu.addEventListener('mouseleave', () => {
      menu.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    });
  });
}

jQuery(document).ready(function(){

    jQuery.getJSON("https://api.ipify.org?format=json", function(data) {
         
     ipAddr = data.ip;

      postIpActions();
    
    });

    if(is_pdp){

      initProductPage();
    
    }

    jQuery(".js-hide").hide();

    handleShopifyInboxClicks();

});